<finfra-stepper
  [stepperFunctionId]="functionId"
  [stepperApplicationId]="applicationId"
  [(stepperData)]="formData"
></finfra-stepper>
